import desanitizeString from '../sanitizeUtil/sanitizeUtil';

const getStatus = (status, schemaArr) => {
  let statusValue;

  schemaArr.forEach((stat) => {
    if (desanitizeString(stat.label) === status) {
      statusValue = stat.value;
    }
  });

  return statusValue;
};

export default getStatus;
